module.exports = __webpack_public_path__ + "static/CV-rough.86c966a9.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CV-rough.pdf
// module id = 321
// module chunks = 114276838955818